export { default } from './HowItWorksView';



// WEBPACK FOOTER //
// ./src/components/views/HowItWorksView/index.js